import { render } from "./TrustSection.vue?vue&type=template&id=77d3905c&scoped=true"
import script from "./TrustSection.vue?vue&type=script&lang=js"
export * from "./TrustSection.vue?vue&type=script&lang=js"

import "./TrustSection.vue?vue&type=style&index=0&id=77d3905c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d3905c"]])

export default __exports__